<template>
  <el-container>

    <el-container>
      <el-aside class="left_menu_container"
                style="z-index:1">
        <leftMenu type="setting" />
      </el-aside>
      <el-main class="work_container">
        <div style="background-color: white;margin-left: 20px;height: 100vh;">
          <el-row style="clear:both;height:40px"></el-row>
          <el-row>
            <el-col :span="23"
                    class="t_l"
                    :offset="1">
              <span class="pageTitle">购买记录 </span>
            </el-col>
          </el-row>
          <div style="clear:both;height: 15px;"></div>
          <el-row>
            <el-col :span="23"
                    class="t_l"
                    :offset="1">
              <div class=" infinite-list"
                   v-infinite-scroll="getOrders"
                   :infinite-scroll-delay=500
                   :infinite-scroll-distance=100
                   :infinite-scroll-immediate=true
                   :infinite-scroll-disabled='infiniteFinish'
                   style="overflow:auto;height: calc(100vh - 166px);">
                <el-table ref="singleTable"
                          :data="orders"
                          highlight-current-row
                          style="width: 100%">

                  <el-table-column property="no"
                                   label="订单号"
                                   width="350">
                  </el-table-column>
                  <el-table-column property="payFinishTime"
                                   label="支付时间">
                  </el-table-column>
                  <el-table-column property="packageName"
                                   label="购买内容">
                  </el-table-column>
                  <el-table-column label="支付金额">
                    <template slot-scope="scope">
                      {{ scope.row.amount }}元
                    </template>
                  </el-table-column>

                  <el-table-column property="vipEndTime"
                                   label="有效期">
                  </el-table-column>

                </el-table>
                <template v-if="infiniteFinish">
                  <div class="noData">
                    <i class="iconfont">&#xe629;</i>
                    数据加载完毕!
                  </div>
                </template>
                <template v-else>
                  <div class="noData">
                    <span class="icon_run">
                      <i class="iconfont">&#xe67b;</i>
                    </span>数据加载中...
                  </div>
                </template>
              </div>
            </el-col>
          </el-row>

        </div>
      </el-main>
    </el-container>

    <!---弹窗相关----->

    <price v-if="priceListDialogVisible"
           :show=priceListDialogVisible />

  </el-container>
</template>

<script>
import Qrcode from 'vue-qr'
import price from './price'
import leftMenu from '../components/left_menu.vue'
export default {

  data: function () {
    return {
      keyword: '',
      userInfo: '',
      menuIndex: '0',
      infiniteFinish: false,
      lastId: -1,
      orders: [],
      total: 1,
      priceListDialogVisible: 0

    }
  },
  filters: {
    genderFilter: function (val) {
      if (val === 'MALE') {
        return '男'
      } else if (val === 'FEMALE') {
        return '女'
      } else {
        return '未知'
      }
    },
    numFilter (value) {
      let realVal = parseFloat(value).toFixed(2)
      return realVal
    }
  },
  methods: {

    getOrders () {
      let _this = this
      this.axios.get(`/webApi/v3/order/listById?orderId=${this.lastId}`).then(response => {
        if (response.data === null || response.data.length < 10) {
          _this.infiniteFinish = true
        }

        _this.orders = _this.orders.concat(response.data)

        if (_this.orders && _this.orders.length > 0) {
          _this.lastId = _this.orders.slice(-1)[0].id
        }
      })
    }

  },
  components: {

    qrcode: Qrcode,
    price,
    leftMenu
  },
  mounted () {
    this.getOrders()
  },
  watch: {

  }
}
</script>
<style lang="less">
@import '../assets/css/index.less';

.priceDialog {
  .el-dialog__header {
    padding: 0px !important;
  }
}
</style>
<style lang="less" scoped>
@import '../assets/css/index.less';

.price_rate {
  position: absolute;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #ff7f7f;
  color: white;
  padding-top: 35px;
  width: 70px;
  font-size: 0.5em;
  top: -22px;
  right: -33px;
  height: 18px;
}

.price_title {
  margin-top: 20px;
  margin-bottom: 15px;
  font-size: 1.2em;
}

.price_total {
  margin-top: 15px;
  margin-bottom: 15px;
}

.price_avg {
  margin-top: 15px;
  margin-bottom: 30px;
}

.price_origin {
  text-decoration: line-through;
  margin-top: 15px;
  margin-bottom: 30px;
}

.imgCaptcha {
  width: 100px;
}

.qrcodeContainer {
  text-align: center !important;
}

.accountAvatar {
  top: 10px;
  position: relative;
}

.avatar-uploader {
  text-align: center !important;
}
</style>
<style lang="less" scoped>
.modifyMobileForm {
  .el-input-group__append {
    z-index: 99;
    background-color: white;
    padding: 0px 5px;
    border-left: 0px !important;
  }
}

.work_container {
  padding: 0px;
  min-width: 930px;

  p {
    text-align: left;
  }

  h6 {
    color: black;
    text-align: left;
  }

  .vipTitle {
    color: black;
    font-size: 1.2em;
    margin: 10px 5px;
  }

  .vipTip {
    font-size: 0.9em;
  }

  .vipTag {
    background-color: #eaf3ff;
    border-radius: 0;
    color: #333333;
    font-size: 1.2em;
    padding: 0px 30px;
    line-height: 60px;
    height: 60px;
    float: left;
    margin-right: 50px;
  }

  .vipBuyBtn {
    width: 135px;
    margin-top: 14px;
  }

  .title_lable {
    width: 100%;
    // text-align-last: justify;
    // text-align: justify;
    // text-justify: distribute-all-lines;
    // width: 86px;
    display: inline-block;
    text-align: left;
  }

  .account_info_item {
    height: 70px;
    width: 700px;
    line-height: 50px;
    text-align: left;
  }
}

.price_package_container {
  padding: 0px 10px !important;
  height: auto !important;
  overflow: hidden;
  width: 125px !important;
  margin-right: 25px;
}

.price_package_container .el-radio__input {
  display: none;
}

.payTypeBtn {
  width: 150px;
  height: 50px !important;

  .el-radio__input {
    top: -9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/orders.vue